/* eslint-disable no-case-declarations */
import { REDUX_ACTIONS } from '../../shared/config/constants';
const initialState = {
  loading: false,
  data: [],
  errorMessage: '',
  paginatedElements: 0,
  marker_data: [],
  searchKey: ''
};
const payTargetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.PAY_TARGETS_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: ''
      };
    case REDUX_ACTIONS.PAY_TARGETS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.payload.data],
        marker_data: [...action.payload.data],
        paginatedElements: action.payload.paginatedElements,
        errorMessage: ''
      };
    case REDUX_ACTIONS.PAY_TARGETS_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
        data: []
      };
    case REDUX_ACTIONS.PAY_TARGETS_SEARCH_CHANGE:
      return {
        ...state,
        searchKey: action.payload.value,
      };
    default:
      return state;
  }
};
export default payTargetsReducer;
